<template>
    <div class="integrations">
        
    </div>
</template>

<script>
    export default {

    }
</script>


// WEBPACK FOOTER //
// Integrations.vue?bd723e8e